import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getSolutionMappedTo } from '../../../../functions/get_solution_to';
import { getSolutionFromProblem } from '../../../../functions/solution';
import '../../../solution_screen/create_solution/create_solution.css';
import '../../../solution_screen/solution_implimentation/solution_imp.css';

export default function WizardSolutionForm({ eventData, problemData, onDataChange, initialData }) {
    const [solutionMappedTo, setSolutionMappedTo] = useState([]);
    const [solutionImages, setSolutionImages] = useState([]);
    const solutionImagesSliderRef = useRef();

    useEffect(() => {
        // Calculate solution mapped to from problem mapped to
        if (problemData?.pickedPMT && eventData?.eventType) {
            const solutions = getSolutionMappedTo(problemData.pickedPMT, eventData.eventType);
            setSolutionMappedTo(solutions);

            // Get solution images from problem mapped to
            const images = getSolutionFromProblem(problemData.pickedPMT, eventData.eventType);
            setSolutionImages(images);

            // Notify parent of solution data
            if (onDataChange) {
                onDataChange({
                    solutionMappedTo: solutions
                });
            }
        } else {
            setSolutionImages([]);
        }
    }, [problemData?.pickedPMT, eventData?.eventType, onDataChange]);

    const settingsSlick = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    // Get principle deficiency display text
    const getPrincipleDeficiencyText = () => {
        if (!problemData?.pickedPD || problemData.pickedPD.length === 0) return '';
        return problemData.pickedPD.join(', ');
    };

    // Get problem mapped to display text
    const getProblemMappedToText = () => {
        if (!problemData?.pickedPMT || problemData.pickedPMT.length === 0) return '';
        return problemData.pickedPMT.join(', ');
    };

    return (
        <div className="wizard-solution-form">
            <div className='solution-view-container'>
                <div className='solution-details-panel'>
                    <div className='detail-field'>
                        <label className='detail-label'>Event Name</label>
                        <div className='detail-value'>{eventData?.eventName || ''}</div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Negative Function Executed</label>
                        <div className='detail-value negative'>{eventData?.negative || ''}</div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Problem Identified from Event</label>
                        <div className='detail-value negative'>{eventData?.problem || ''}</div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Principle Deficiency</label>
                        <div className='detail-value'>
                            {getPrincipleDeficiencyText()}
                        </div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Problem Mapped to</label>
                        <div className='detail-value'>
                            {getProblemMappedToText()}
                        </div>
                    </div>

                    <div className='detail-field'>
                        <label className='detail-label'>Solution Mapped</label>
                        <div className='detail-value'>
                            {solutionMappedTo.join(', ') || ''}
                        </div>
                    </div>
                </div>

                {solutionImages.length > 0 && (
                    <div className='solution-images-panel'>
                        <div className="images">
                            <h1 className='title'>Solution Mapped To</h1>
                            <Slider ref={solutionImagesSliderRef} className='carasoul-box' {...settingsSlick}>
                                {solutionImages.map((image, index) => (
                                    <div key={index} className="carousel-slide">
                                        <img alt={`Solution Mapped To ${index + 1}`} src={image} className="solution-image" />
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

// Export validation function (solution step is read-only, so always valid)
export const validateSolutionForm = (solutionData) => {
    return { valid: true };
};
